module.exports = __webpack_public_path__ + "static/img/img_5.ed798b68.jpg";